var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 103,
    viewBox: "0 0 125 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.512 1.00001H79.1651C78.035 0.999327 76.9504 1.36594 76.1485 2.01972L3.48427 61.6728C1.8932 62.9854 1 64.7618 1 66.6136C1 68.4653 1.8932 70.2417 3.48427 71.5543L38.0863 99.9606C39.6852 101.267 41.849 102 44.1047 102C46.3603 102 48.5242 101.267 50.1231 99.9606L122.758 40.3317C123.554 39.6734 124.001 38.7831 124 37.8553V7.99231C124.005 7.07486 123.79 6.16558 123.366 5.31679C122.941 4.46801 122.317 3.69648 121.528 3.04661C120.739 2.39674 119.801 1.88135 118.769 1.53011C117.736 1.17887 116.63 0.998715 115.512 1.00001V1.00001Z",
    stroke: "#596394",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.357 28.1967C98.4854 28.1967 96.6556 27.741 95.0993 26.8873C93.543 26.0336 92.33 24.8202 91.6137 23.4006C90.8974 21.9809 90.71 20.4188 91.0752 18.9117C91.4403 17.4047 92.3417 16.0203 93.6652 14.9338C94.9887 13.8472 96.675 13.1073 98.5108 12.8075C100.347 12.5077 102.249 12.6616 103.979 13.2496C105.708 13.8376 107.186 14.8334 108.226 16.1111C109.266 17.3887 109.821 18.8908 109.821 20.4274C109.821 22.488 108.824 24.4641 107.049 25.9211C105.274 27.3781 102.867 28.1967 100.357 28.1967Z",
    fill: "#596394"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/labelIcon.81e958a2a3bfef5784eb51a218468d45.svg";
export { ForwardRef as ReactComponent };